/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignStatusChangeDataSchema = z.object({
	status: z.string(),
})

export type CampaignStatusChangeDataSchema = z.infer<typeof campaignStatusChangeDataSchema>
